<template>
  <base-modal :show.sync="$show" title="Share Badge" @closeModal="closeModal">
    <b-row class="align-content-between">
      <b-col cols="12" class="p-0 mb-3">
        <b-col cols="12" class="text-center">
          <img
            ref="img__badge"
            :src="badgeImageSrc"
            alt=""
            class="container__badge container__badge--centered"
          />
        </b-col>
        <b-col
          v-if="credential.learning_unit.level_type"
          class="text-primary font-weight-bold text-center mt-4"
        >
          <span class="mr-1"
            ><img
              :src="
                credential.learning_unit.level_type === 'CAREER_SPECIFIC'
                  ? require('@/assets/learning-unit-types/specific.svg')
                  : require('@/assets/learning-unit-types/academic.svg')
              "
              style="height: 16px"
            />
          </span>
          <span class="text__mc-type">{{
            credential.learning_unit.level_type === 'CAREER_SPECIFIC'
              ? 'Career Specific'
              : 'Academic Focused'
          }}</span>
        </b-col>
        <b-col
          v-if="credential.learning_unit"
          ref="text-lu-title"
          class="h5 font-weight-bold mt-3 text__mc-title text-center card__title-truncate-overflow text-lu-title"
          cols="12"
          >{{ credential.learning_unit.name }}
        </b-col>
      </b-col>

      <b-col class="p-0">
        <b-col cols="12" class="text-center">
          <div class="text-black-50 mb-3">Issued by</div>
          <img
            ref="img__issued-by"
            src="@/assets/kmutt-logo.png"
            width="30.2px"
            class="mb-3 img__issued-by"
          />
          <div ref="text-issued-on" class="mb-3 text-issued-on">
            <span class="text-black-50">Issued on </span
            >{{ formatedDatetime(credential.accredible_credential.issued_on, 'MMM D, YYYY') }}
          </div>
          <div>Always included badge image and issued details</div>
        </b-col>

        <b-col cols="12">
          <hr class="my-3" />
        </b-col>

        <b-col v-if="link">
          <div class="mb-3">Get link</div>
          <b-alert v-if="show_evidence" ref="alert__expire-link" class="alert__expire-link" show
            >Link will expire in 2 weeks</b-alert
          >
          <div class="d-flex flex-row">
            <b-col cols="8" sm="9" class="p-0">
              <b-form-input
                ref="badge__link"
                v-model="link"
                class="badge__link"
                disabled
              ></b-form-input>
            </b-col>
            <b-col cols="4" sm="3" class="p-0" style="text-align: end">
              <b-button ref="btn__copy" variant="outline-primary" class="btn__copy" @click="onCopy"
                >Copy</b-button
              >
            </b-col>
          </div>
        </b-col>

        <b-col v-else cols="12">
          <div class="mb-3">Additional details <span class="text-black-50">(Optional)</span></div>

          <b-form-checkbox
            id="checkbox-evidence"
            ref="option__evidence"
            v-model="show_evidence"
            name="checkbox-evidence"
            :value="true"
            :unchecked-value="false"
            class="mb-3 option__evidence"
            :disabled="submitting"
            @change="onChange"
          >
            Evidence (link will expire after 2 weeks)
          </b-form-checkbox>
          <b-form-checkbox
            v-show="show_evidence"
            id="checkbox-comment_feedback"
            ref="option__feedback"
            v-model="show_feedback"
            name="checkbox-comment_feedback"
            class="mb-3 ml-4 option__feedback"
            :value="true"
            :unchecked-value="false"
            :disabled="submitting"
          >
            Comment, feedback
          </b-form-checkbox>
          <b-form-checkbox
            id="checkbox-recommendation"
            ref="option__recommendation"
            v-model="show_recommendation"
            name="checkbox-recommendation"
            :value="true"
            :unchecked-value="false"
            class="mb-3 option__recommendation"
            :disabled="submitting"
          >
            Recommendation
          </b-form-checkbox>
        </b-col>
      </b-col>
    </b-row>

    <template #modal-footer>
      <b-button
        v-if="link"
        ref="btn__done"
        variant="success"
        class="btn__done"
        @click="$emit('update:show', false)"
      >
        Done
      </b-button>

      <span v-else>
        <b-button
          ref="btn__cancel"
          variant="link"
          class="btn-link-dark btn__cancel"
          :disabled="submitting"
          @click="$emit('update:show', false)"
        >
          Cancel
        </b-button>
        <b-button ref="btn__next" variant="success" class="btn__next" @click="getLink">
          <span v-if="!submitting">Next</span>
          <span v-else class="pr-2 pl-2">
            <b-spinner label="Loading..." variant="secondary" small />
          </span>
        </b-button>
      </span>
    </template>
  </base-modal>
</template>

<script>
import { datetimeMixin } from '@/mixins/datetimeMixin';
import BaseModal from '@/components/base-components/BaseModal.vue';
import Credential from '@/models/Credential';
import CredentialLink from '@/models/CredentialLink';
import { notificationMixin } from '@/mixins/notificationMixin';

export default {
  components: {
    BaseModal
  },

  mixins: [datetimeMixin, notificationMixin],

  props: {
    show: {
      type: Boolean,
      default: false
    },

    credentialId: {
      type: [Number, String],
      default: null
    }
  },

  data() {
    return {
      show_evidence: false,
      show_feedback: false,
      show_recommendation: false,
      submitting: false,
      link: null
    };
  },

  computed: {
    $show: {
      get() {
        return this.show;
      },

      set(v) {
        this.$emit('update:show', v);
      }
    },

    credential() {
      return Credential.query().where('id', this.credentialId).with('learning_unit').first();
    },

    learningUnit() {
      return this.credential ? this.credential.learning_unit : null;
    },

    baseURL() {
      return window.location.origin;
    },

    badgeImageSrc() {
      const { learning_unit = null } = this.credential;
      let link = '';
      if (learning_unit && learning_unit.badge_image && learning_unit.badge_image.length) {
        link = learning_unit.badge_image[0].url;
      }

      return link;
    }
  },

  methods: {
    onChange(show_evidence) {
      if (!show_evidence) {
        this.show_feedback = false;
      }
    },

    closeModal() {
      this.show_evidence = false;
      this.show_feedback = false;
      this.show_recommendation = false;
      this.link = null;
    },

    async getLink() {
      const { credential, show_evidence, show_feedback, show_recommendation } = this;
      try {
        const {
          response: { data }
        } = await CredentialLink.api().getCode({
          credential: credential.id,
          show_evidence,
          show_feedback,
          show_recommendation
        });
        if (data) {
          this.link = this.baseURL + '/badge-detail/' + data;
        } else {
          this.notiError('Failed to get link.');
        }
      } catch (error) {
        console.error('Failed to get link: ', error);
        this.notiError('Failed to get link.');
      }
    },

    async onCopy() {
      try {
        const toCopy = this.link;
        await navigator.clipboard.writeText(toCopy);
        this.notiSuccessDefault('Your link has been copied to clipboard.');
      } catch (error) {
        console.error('Failed to copy: ', error);
        this.notiError('Failed to copy.');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card__title-truncate-overflow {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
